import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useProductListLogic from './ProductListLogic';
import BasicProductListSkinComplete from './skins/BasicProductListSkinComplete';
import ProductListProperties from './ProductList.properties';

/**
 * 상품 목록 스킨 가능 컴포넌트
 */
export const ProductListSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.PRODUCT_LIST,
  name: '상품 목록',
  category: 'ecommerce',
  options: ProductListProperties as any,
  defaultSkin: 'basic',
  supportsExternalSkins: true,
  internalSkins: {
    basic: BasicProductListSkinComplete as any
  },
  useLogic: useProductListLogic as any,
  defaultProps: {
    itemsPerRow: 4,
    itemsPerPage: 20,
    showPrice: true,
    showStock: true,
    showAddToCart: true,
    showPagination: true,
    sortBy: 'created',
    sortOrder: 'desc',
    priceColor: '#ff6b6b',
    cartButtonColor: '#007bff',
    stockTextColor: '#28a745'
  }
};